export interface MacMiniInfo {
  id: string
  name: string
  model: string
  status: string
  ansibleId?: string
  ansibleName?: string
  terminalId?: string
}

export interface PnsMacMiniUser {
  id: string
  macMiniId: string
  macMini?: MacMiniInfo
  username: string
  wispPort: number
  serviceFqdn?: string
  status: PnsMacMiniUserStatus
  wispStatus: WispStatus
  lastActivity?: string
  isActive: boolean
  createdAt: string
  updatedAt: string
  appleIdConfigId?: string
  appleIdConfig?: import('./pns-phone-number').AppleIdConfig
}

export enum PnsMacMiniUserStatus {
  AVAILABLE = 'AVAILABLE',
  RESERVED = 'RESERVED',
  ICLOUD_SETUP_IN_PROGRESS = 'ICLOUD_SETUP_IN_PROGRESS',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  TERMINATED = 'TERMINATED',
}

export enum WispStatus {
  STARTING = 'STARTING',
  RUNNING = 'RUNNING',
  STOPPED = 'STOPPED',
}

export interface PaginatedMacMiniUserResponse {
  data: PnsMacMiniUser[]
  pagination: {
    total: number
    count: number
    limit: number
    offset: number
    hasMore: boolean
    currentPage: number
    totalPages: number
  }
}

export interface PnsMacMiniUserCountResponse {
  total: number
  byStatus: {
    [key in PnsMacMiniUserStatus]: number
  }
  byWispStatus: {
    [key in WispStatus]: number
  }
}
